<template>
  <div>
    <b-container>
      <content-block :contentId="contentId" v-if="contentId"></content-block>
      <b-row v-if="studentOpportunityAdditionalMaterialCopy">
        <b-col sm="6">
          <template v-if="studentOpportunityAdditionalMaterial.additionalMaterialType.name == 'PIP Form'">
            <b-button variant="primary flex-float-right" class="mr-2 mt-2"
              v-if="studentOpportunityAdditionalMaterialCopy.additionalMaterialType.additionalMaterialTypeOptions.length">
              <router-link target="_blank" rel="noopener noreferrer" style="color:white; text-decoration:none;"
                :to="{ name: 'PipDetails', params: { studentOpportunityId: studentOpportunity.studentOpportunityId } }">View
                PIP</router-link>
            </b-button>
          </template>
          <b-button
            v-if="studentOpportunityAdditionalMaterialCopy.additionalMaterialType.additionalMaterialTypeOptions.length"
            @click="show = true" variant="primary flex-float-right" class="mt-2">{{ modalButtonLabel }}</b-button>

          <h5 class="mt-2">Latest submission</h5>
          <div>
            <a :href="getFileHref(studentOpportunityAdditionalMaterialCopy.currentFile)"
              v-if="studentOpportunityAdditionalMaterialCopy.currentFile">
              {{ studentOpportunityAdditionalMaterialCopy.currentFile.fileName }} - {{
                studentOpportunityAdditionalMaterialCopy.currentStatus.createdDate | formatDate }}
            </a>
            <span class="current-status-name">
              {{
                studentOpportunityAdditionalMaterialCopy.currentStatus.studentOpportunityAdditionalMaterialStatusDefinition.name
              }}
              <span
                v-if="studentOpportunityAdditionalMaterialCopy.currentStatus.studentOpportunityAdditionalMaterialStatusDefinition.name != 'Not Submitted'">
                - {{ studentOpportunityAdditionalMaterialCopy.currentStatus.createdDate | formatDate }} - {{
                  studentOpportunityAdditionalMaterialCopy.currentStatus.createdBy }}</span>
            </span>
          </div>
          <b-alert variant="warning"
            :show="studentOpportunityAdditionalMaterialCopy.currentStatus.studentOpportunityAdditionalMaterialStatusDefinition.preventResubmission">
            {{
              studentOpportunityAdditionalMaterialCopy.currentStatus.studentOpportunityAdditionalMaterialStatusDefinition.resubmissionMessage
            }}
          </b-alert>
        </b-col>
        <b-col sm="6" v-if="this.editable">
          <b-form inline class="pull-right">
            <label for="status-select" class="mr-sm-2">Status</label>
            <b-form-select id="status-select" v-model="statusId" :options="additionalMaterialStatuses"
              value-field="studentOpportunityAdditionalMaterialStatusDefinitionId" text-field="name"></b-form-select>
            <b-button variant="primary" class="ml-sm-2" @click="clickStatus">Set Status</b-button>
          </b-form>

          <b-form inline class="pull-right mt-sm-2">
            <label for="file-select" class="mr-sm-2" :class="{ 'invalid-label': $v.file.$error }">File</label>
            <b-form-file id="file-select" v-model="file" plain></b-form-file>
            <b-button variant="primary flex-float-right" class="mt-sm-2" @click="submitFile">Upload</b-button>
            <span class="span-feedback invalid-feedback" v-if="$v.file.$error">
              You must select a file.
            </span>
          </b-form>
        </b-col>

        <!-- {{studentOpportunityAdditionalMaterial}} -->
        <b-alert variant="success" :show="hasBeenApproved" class="mt-sm-2">'{{
          studentOpportunityAdditionalMaterial.additionalMaterialType.name }}' has been
          approved.</b-alert>
      </b-row>

      <b-collapse v-model="showMore"
        :id="'collapse' + studentOpportunityAdditionalMaterialCopy.studentOpportunityAdditionalMaterialId">
        <h5 class="mt-2">All submission</h5>
        <div v-for="file in studentOpportunityAdditionalMaterialCopy.studentOpportunityAdditionalMaterialFiles"
          :key="file.studentOpportunityAdditionalMaterialFileId">
          <a :href="getFileHref(file)">
            {{ file.fileName }} - {{ file.createdDate | formatDate }} - {{ file.createdBy }}
          </a>
        </div>
      </b-collapse>

    </b-container>
    <div class="accordion-control"
      v-if="studentOpportunityAdditionalMaterialCopy.studentOpportunityAdditionalMaterialFiles.length > 0">
      <a href="" @click.prevent="showMore = !showMore">{{ showMore ? 'Show less' : 'Show more' }}</a>
    </div>

    <additional-material-modal :modalId="modalId" :show="show" :title="modalButtonLabel"
      :additionalMaterialType="studentOpportunityAdditionalMaterialCopy.additionalMaterialType"
      :studentOpportunityAdditionalMaterial="studentOpportunityAdditionalMaterialCopy"
      :studentOpportunityAdditionalMaterialId="studentOpportunityAdditionalMaterialCopy.studentOpportunityAdditionalMaterialId"
      :studentOpportunity="studentOpportunity" :userId="studentOpportunityCopy.asuriteId" @hideModal="hideModal"
      @complete="$emit('refresh')" />

    <email-modal :show="showEmailModal"
      :additionalMaterialType="studentOpportunityAdditionalMaterialCopy.additionalMaterialType"
      :studentOpportunity="studentOpportunity" :message="emailMessage" @hideModal="showEmailModal = false"
      @complete="completeEmail" />
  </div>
</template>

<script>
import { mapActions } from "vuex"
import studentOpportunityApi from "../../api/studentOpportunity"
import toastr from "toastr"
import ToastrSettings from "../../settings/toastr-settings"
import { required } from "vuelidate/lib/validators"
import * as _ from "lodash" // eslint-disable-line no-unused-vars
import contentBlock from "../content/content-block"
import additionalMaterialModal from "../placements/additional-material-modal"
import emailModal from "../placements/email-modal"
// import termsApi from "../../api/terms";

export default {
  data() {
    return {
      // make a copy to avoid mutating props
      studentOpportunityAdditionalMaterialCopy: null,
      studentOpportunityCopy: null,
      statusId: null,
      file: null,
      showMore: false,
      contentId: null,
      show: false,
      showEmailModal: false,
      contact: {},
      goals: [],
      submitted: false,
      step: 0,
      emailMessage: ""
      // terms: []
    }
  },

  components: {
    "content-block": contentBlock,
    additionalMaterialModal,
    emailModal
  },

  props: {
    studentOpportunityAdditionalMaterial: {
      type: Object,
      require: true
    },

    studentOpportunity: {
      required: true,
      type: Object
    },

    additionalMaterialStatuses: {
      type: Array,
      required: true
    },

    editable: {
      type: Boolean,
      required: false
    }
  },

  validations: {
    file: {
      required
    }
  },

  watch: {
    studentOpportunityAdditionalMaterial: function () {
      this.studentOpportunityAdditionalMaterialCopy = this.studentOpportunityAdditionalMaterial
    },
    studentOpportunity: function () {
      this.studentOpportunityCopy = this.studentOpportunity
    },
    selectedStatus: function () {
      // reset email template when status is changed
      this.emailMessage = ""
    }
  },

  computed: {
    modalId: function () {
      return (
        "generate-modal" +
        this.studentOpportunityAdditionalMaterialCopy
          .studentOpportunityAdditionalMaterialId
      )
    },
    hasBeenApproved: function () {
      return (
        this.studentOpportunityAdditionalMaterialCopy.currentStatus
          .studentOpportunityAdditionalMaterialStatusDefinition.name ===
        "Approved"
      )
    },
    modalButtonLabel: function () {
      // console.log("hello")
      // console.log(
      //   this.studentOpportunityAdditionalMaterialCopy.additionalMaterialType
      //     .actionLabel
      // )
      // console.log("world")

      if (this.studentOpportunityAdditionalMaterialCopy.actionLabel) {
        return this.studentOpportunityAdditionalMaterialCopy
          .additionalMaterialType.actionLabel
      }
      return this.studentOpportunityAdditionalMaterialCopy
        .additionalMaterialType.name
    },
    selectedStatus: function () {
      return _.find(
        this.additionalMaterialStatuses,
        additionalMaterialStatus => {
          return (
            additionalMaterialStatus.studentOpportunityAdditionalMaterialStatusDefinitionId ===
            this.statusId
          )
        }
      )
    },
    statusNotification: function () {
      return _.find(
        this.studentOpportunityAdditionalMaterial.additionalMaterialType
          .notifications,
        notification => {
          return notification.status.name === this.selectedStatus.name
        }
      )
    }
  },

  methods: {
    ...mapActions("additionalMaterials", [
      "setGoals",
      "setUserId",
      "setStudentOpportunityId",
      "setStudentOpportunityAdditionalMaterialId",
      "setContact",
      "setStudentOpportunity",
      "setStudentOpportunityAdditionalMaterial",
      "setSupervisors",
      "reset"
    ]),
    getFileHref: function (file) {
      if (this.studentOpportunityAdditionalMaterialCopy.currentFile) {
        return (
          process.env.VUE_APP_BASE_URI +
          "/api/Downloads/StudentAdditionalMaterialFile?id=" +
          file.studentOpportunityAdditionalMaterialFileId
        )
      }
      return ""
    },

    clickStatus: function () {
      if (
        this.selectedStatus &&
        this.statusNotification &&
        this.statusNotification.messageTemplate
      ) {
        this.emailMessage = this.statusNotification.messageTemplate
        this.showEmailModal = true
      } else {
        this.setStatus()
      }
    },

    completeEmail(message) {
      this.emailMessage = message.message
      this.setStatus()
    },

    setStatus: function () {
      var that = this

      studentOpportunityApi
        .postFileStatus(
          this.studentOpportunityAdditionalMaterialCopy
            .studentOpportunityAdditionalMaterialId,
          this.statusId
        )
        .then(() => {
          this.studentOpportunityAdditionalMaterialCopy.currentStatus.studentOpportunityAdditionalMaterialStatusDefinition = this.selectedStatus

          var options = {}
          if (this.emailMessage != "") {
            options.message = this.emailMessage
          }

          if (this.statusNotification && this.statusNotification.actionEvent) {
            studentOpportunityApi
              .postCallbackRequest(
                this.statusNotification.actionEvent,
                this.studentOpportunity.studentOpportunityId,
                this.studentOpportunityAdditionalMaterial
                  .studentOpportunityAdditionalMaterialId,
                options
              )
              .then(function () {
                that.$emit("refresh")
              })
          } else {
            that.$emit("refresh")
          }

          // Toastr Message
          toastr.options = ToastrSettings
          toastr.success("The status has been set.", "Success")
        })
        .catch(function (error) {
          console.log(error)
        })
    },

    submitFile: function () {
      var that = this
      this.$v.$touch()

      if (!this.$v.$invalid) {
        var formData = {}
        formData.studentOpportunityAdditionalMaterialId = this.studentOpportunityAdditionalMaterialCopy.studentOpportunityAdditionalMaterialId
        var fileList = []
        fileList.push(this.file)
        studentOpportunityApi
          .postFile(formData, fileList)
          .then(function () {
            // refresh data
            that.$v.$reset()
            that.file = null
            that.$emit("refresh")

            // Toastr Message
            toastr.options = ToastrSettings
            toastr.success("The file has been uploaded.", "Success")
          })
          .catch(function (error) {
            console.log(error)
          })
      }
    },

    hideModal: function (item) {
      if (item.id == this.modalId) {
        this.show = false
      }
    }
  },

  created() {
    this.studentOpportunityAdditionalMaterialCopy = this.studentOpportunityAdditionalMaterial
    this.studentOpportunityCopy = this.studentOpportunity
    this.statusId = this.studentOpportunityAdditionalMaterial.currentStatus.studentOpportunityAdditionalMaterialStatusDefinitionId
    this.contentId = this.studentOpportunityAdditionalMaterialCopy.additionalMaterialType.description
    this.goals = this.studentOpportunity.goals
    this.setGoals(this.studentOpportunity.goals)
    this.setUserId(this.userId)
    this.setStudentOpportunityId(this.studentOpportunity.studentOpportunityId)
    this.setStudentOpportunityAdditionalMaterialId(
      this.studentOpportunityAdditionalMaterial
        .studentOpportunityAdditionalMaterialId
    )
    this.setStudentOpportunity(this.studentOpportunityCopy)
    this.setStudentOpportunityAdditionalMaterial(
      this.studentOpportunityAdditionalMaterialCopy
    )
    if (this.studentOpportunity.studentOpportunityContacts.length) {
      this.contact = this.studentOpportunity.studentOpportunityContacts[0].siteContact
      this.setContact(
        this.studentOpportunity.studentOpportunityContacts[0].siteContact
      )
    }
    this.setSupervisors(this.studentOpportunity.studentOpportunityContacts)

    // var currDate = new Date();

    // termsApi.getCurrentAndFutureTerms().then(response => {
    //   this.terms = response.data;

    // var termStart = this.terms[0].termStart;

    // console.log("111111111111111111111111");
    // console.log(this.terms[0].termStart);
    // console.log("22222222222222222");

    // if (this.terms[0].TermStart <= currDate+21)
    // {
    //   console.log("ok");
    // }
    // });
  }
}
</script>

<style scoped>
h5 {
  font-size: 0.9em;
}

label {
  font-weight: bold;
}

.form-control-file {
  width: 70%;
}

.flex-float-right {
  margin-left: auto;
}

.invalid-label {
  color: #dc3545;
}

.alert-success {
  width: 100%;
}

.accordion-control {
  width: 100%;
  text-align: center;
  background-color: #e9e9e9;
  border: 1px solid #d1d2d3;
  margin-top: 1em;
}
</style>
